import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginValidateemailcodeforforgotusernameMutationRequest,
  PostApiLoginValidateemailcodeforforgotusernameMutationResponse,
} from "../../../types/PostApiLoginValidateemailcodeforforgotusername";

export function getPostApiLoginValidateemailcodeforforgotusernameUrl() {
  return `/api/Login/ValidateEmailCodeForForgotUsername` as const;
}

/**
 * {@link /api/Login/ValidateEmailCodeForForgotUsername}
 */
export async function postApiLoginValidateemailcodeforforgotusername(
  data?: PostApiLoginValidateemailcodeforforgotusernameMutationRequest,
  config: Partial<
    RequestConfig<PostApiLoginValidateemailcodeforforgotusernameMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginValidateemailcodeforforgotusernameMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginValidateemailcodeforforgotusernameMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginValidateemailcodeforforgotusernameUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
